export default class ComboPromoButton {

    constructor() {
        this.articleNumber = null;
        this.imageIdToCombo = null;
        this.destinationDomElement = null;
        this.qa = {};
    }

    // API: DON'T CHANGE - called by FT5
    loadButton(articleNumber, destinationDomElement, imageId, preset, emid, variationId) {
        this.variationId = variationId;

        if (imageId && typeof imageId !== "string") {
            throw new Error("imageId has to be a string");
        }

        const STATUS_CODE_OK = 200;
        let url = `/combo-combopromo/button/${articleNumber}`;

        this.articleNumber = articleNumber;
        this.destinationDomElement = destinationDomElement;

        this.qa.buttonCall = {
            variationId,
            articleNumber,
            "target": destinationDomElement,
        };

        window.o_util.ajax({
            "url": url,
            "method": "GET",
            "headers": {
                "accept": "application/json"
            }
        }).then((xhr) => {

            if (xhr.status === STATUS_CODE_OK) {
                let responseAsJSON = this.parseJson(xhr);

                if (responseAsJSON) {
                    this.imageIdToCombo = responseAsJSON.imageIdToCombo;
                    this.comboType = responseAsJSON.comboType || "OUTFIT";
                    this.title = responseAsJSON.title;
                    this.cssComboTypeImageClass = responseAsJSON.cssComboTypeImageClass;
                    this.cssFormatImageClass = responseAsJSON.cssFormatImageClass;
                    this.cssFormatButtonClass = responseAsJSON.cssFormatButtonClass;
                    this.comboIsCGI = responseAsJSON.comboIsCGI || false;

                    let usedImageId = this.imageExists(imageId) ? imageId : responseAsJSON.newestComboImageId;

                    if (this.imageExists(usedImageId)) {
                        this.injectButtonHtml(usedImageId);
                        let comboId = this.imageIdToCombo[usedImageId].comboId;
                        let source = this.imageIdToCombo[usedImageId].source;

                        if (emid) {
                            window.o_tracking.bct.sendEventMergeToTrackingServer(this.buildInitialViewTracking(usedImageId), emid);
                            window.o_p13n_combopromo.tracking.sendPromoButtonMergePageImpression(comboId, source, this.comboType, emid, this.variationId, this.comboIsCGI)
                        } else {
                            window.o_tracking.bct.sendMergeToTrackingServer(this.buildInitialViewTracking(usedImageId));
                            window.o_p13n_combopromo.tracking.sendPromoButtonPageImpressionTrackingEvent(comboId, source, this.comboType, this.variationId, this.comboIsCGI)
                        }
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.log(`Expected json from call to ${url} but got ${xhr.response}`);
                }
            }
        });

        return this;
    }

    // API: DON'T CHANGE - called by FT5
    update(imageId /*, eventMergeId*/) {
        if (!this.imageExists(imageId)) {
            return;
        }

        this.injectButtonHtml(imageId);
    }

    imageExists(imageId) {
        return this.imageIdToCombo && this.imageIdToCombo[imageId];
    }

    injectButtonHtml(imageId) {
        let comboLink = this.buildHrefLinkFor(imageId);
        let comboText = this.title;
        let comboTypeImageClass = this.cssComboTypeImageClass;
        let formatImageClass = this.cssFormatImageClass;
        let cssFormatButtonClass = this.cssFormatButtonClass;
        let imagePreset = this.comboType === "ROOM" ? "poi_room" : "poi_outfit";
        const imageUrl = `https://i.otto.de/i/otto/${imageId}?$${imagePreset}$`;
        let comboId = this.imageIdToCombo[imageId].comboId;
        let source = this.imageIdToCombo[imageId].source;

        this.destinationDomElement.innerHTML =
            `<a class="${cssFormatButtonClass}"
                href="${comboLink}"
                onclick='window.o_p13n_combopromo.tracking.sendPromoButtonClickTrackingEvent("${comboId}", "${source}", "${this.comboType}", "${this.variationId}", ${this.comboIsCGI})'>
            </picture>
                <picture>
                    <source srcset="${imageUrl + '&amp;fmt=webp'}" type="image/webp">
                    <img class="${comboTypeImageClass}  ${formatImageClass}" 
                         src="${imageUrl}">
                 </picture>
                 <span class="combo_combopromo_button_text_wrapper">
                     <span class="combo_combopromo_button_text pl_m50">${comboText}</span>
                 </span>
             </a>`.replace(/\n\s*/gm, "");
    }

    parseJson(xhr) {
        try {
            return JSON.parse(xhr.responseText);
        } catch (e) {
            return null;
        }

    }

    buildHrefLinkFor(imageId) {
        return `/k/${this.imageIdToCombo[imageId].comboId}?a=${this.articleNumber}`;
    }

    getQA() {
        return this.qa;
    }

    generateTrackingValue(imageId, promoActivity) {
        const combo = this.imageIdToCombo[imageId];
        return `${combo.comboId}∞1$1∞1∞1∞${combo.source}∞${promoActivity}`
    }

    buildInitialViewTracking(imageId) {
        return {
            "promo_ComboButton": this.generateTrackingValue(imageId, "view"),
            "promo_ComboType": this.comboType,
            "promo_IsCgiCombo": this.comboIsCGI === true ? "true" : "false"
        };
    }
}
